import { useFeatureFlagEnabled } from 'posthog-js/react'

const FLOW_STATE_GENERATION_FLAG = 'Flow-State-Generation'

export const useFlowStateGenerationEnabled = () => useFeatureFlagEnabled(FLOW_STATE_GENERATION_FLAG)
